import { useScriptLimits } from "@/hooks/useScriptLimits";

export function Watermark() {
  const { tier } = useScriptLimits();
  
  // Only show watermark for free users
  if (tier !== "free") return null;

  return (
    <div className="fixed bottom-20 right-4 z-30 text-foreground/30 font-serif italic text-lg pointer-events-none select-none">
      Vesper 星語
    </div>
  );
}
